<template>
    <div class="w-full">
        <div class="inline">
            <page-headline>{{$t('pages.auctions.planning.upload.title')}}</page-headline>
        </div>
        <p>{{$t('pages.auctions.planning.upload.p_1')}}<br>{{$t('pages.auctions.planning.upload.p_2')}}</p>

        <ul class="pt-8 pb-10 pl-10 list-disc">
            <li>{{$t('pages.auctions.planning.upload.restrictions.1')}}</li>
            <li>
                {{$t('pages.auctions.planning.upload.restrictions.2.text')}}
                <ul class="pl-10 list-disc">
                    <li>{{$t('pages.auctions.planning.upload.restrictions.2.children.1')}}</li>
                    <li>{{$t('pages.auctions.planning.upload.restrictions.2.children.2')}}</li>
                    <li>{{$t('pages.auctions.planning.upload.restrictions.2.children.3')}}</li>
                </ul>
            </li>
            <li>{{$t('pages.auctions.planning.upload.restrictions.3')}}</li>
            <li>{{$t('pages.auctions.planning.upload.restrictions.4')}}</li>
        </ul>
        <div class="mb-8">
            <file-input
                ref="file"
                :selectLabel="$t('pages.auctions.planning.upload.button')"
                :uploadLabel="$t('pages.auctions.planning.upload.upload')"
                :accept="'.csv'"
                @input="onFileSelected"
                @upload="onFileUpload"
                :uploading="uploadingFile"
                :value="uploadFile"
                :info="uploadInfo"
                :warnings="uploadWarnings"
                :errors="uploadErrors"
            />
        </div>
        <div class="w-2/3 border-t border-gray-700 flex pt-8">
            <div class="w-full flex flex-row mt-8 space-x-4">
                <div class="bg-white tile h-full">
                    <div class="px-4 py-5 sm:p-6">
                        <div class="sm:items-start sm:justify-between">
                            <div>
                                <h3 class="text-xl leading-6 font-medium">{{$t('pages.auctions.planning.overview.title_3')}}</h3>
                                <div class="mt-2 max-w-xl text-sm text-gray-500">
                                    <p v-html="$t('pages.auctions.planning.overview.teaser_3')"></p>
                                </div>
                            </div>
                            <div class="mt-5 sm:flex-shrink-0 sm:flex sm:items-center">
                                <a :href="route('auctions.planning.download.currentData', {})">
                                    <button type="button" class="btn btn-primary">
                                        {{$t('pages.auctions.planning.overview.download_button_label')}}
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-white tile h-full">
                    <div class="px-4 py-5 sm:p-6">
                        <div class="sm:items-start sm:justify-between">
                            <div>
                                <h3 class="text-xl leading-6 font-medium">{{$t('pages.auctions.planning.upload.download_teaser')}}</h3>
                                <div class="mt-2 max-w-xl text-sm text-gray-500">
                                    <p v-html="$t('pages.auctions.planning.upload.empty_template')"></p>
                                </div>
                            </div>
                            <div class="mt-5 sm:flex-shrink-0 sm:flex sm:items-center">
                                <a :href="route('auctions.planning.download.template', {})">
                                    <button type="button" class="btn btn-primary">
                                        {{$t('pages.auctions.planning.upload.download_template')}}
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeadline from "@/Shared/PageHeadline";
import FileInput from "@/Shared/FileInput";
import FileUploadService from "../../Services/FileUploadService";
import {ErrorTypes} from "../../mixins/ErrorTypes";


export default {
    mixins: [ErrorTypes],
    components: {
        PageHeadline,
        FileInput
    },
    data() {
        return {
            uploadFile: undefined,

            uploadInfo: {
                messages: [],
                headline: String,
                displayTitle: false,
            },
            uploadWarnings: {
                messages: [],
                headline: String,
                displayTitle: true,
            },
            uploadErrors: {
                messages: [],
                headline: String,
                displayTitle: true,
            },
            uploadingFile: false
        }
    },
    methods: {
        onFileSelected(val) {
            this.uploadFile = val;
        },
        onFileUpload() {
            this.clearAll();
            let that = this;
            let promise = FileUploadService.uploadFile(this.uploadFile, this.route('auctions.planning.upload'));
            this.uploadingFile = true;
            promise.then((resp) => {
                let status = resp.request.status;

                if(status === 200) {
                    that.uploadInfo = {
                        headline: that.$t(
                            that.uploadWarnings.messages.length > 0 ?
                                'shared.planning_upload.succeeded_with_warnings' : 'shared.planning_upload.succeeded',
                            {file: that.uploadFile.name}
                        )
                    };
                    that.setMessages(resp.data);
                } else if(status === 400 || status === 415 || status === 422) {
                    // Bad request
                    that.uploadErrors = {
                        headline: that.$t('shared.planning_upload.error_title', {file: that.uploadFile.name, code: status})
                    };
                    that.setMessages(resp.response.data);
                } else {
                    that.uploadErrors.headline = that.$t('shared.planning_upload.error_title', {file: that.uploadFile.name, code: status});
                    that.uploadErrors.messages = [...(resp.message ? resp.message : that.$t('shared.planning_upload.unknown_error_try_again'))];
                }
            }).catch((ex) => {
                that.clearAll();
                that.uploadErrors.headline = that.$t('shared.planning_upload.error_title', {file: that.uploadFile.name, code: ex.code});
                that.uploadErrors.messages = [...ex.message];
            }).finally(() => {
                that.uploadFile = undefined;
                that.uploadingFile = false;
            });
        },
        setMessages(data) {
            let that = this;
            if(data && data.info && data.info.length > 0) {
                that.uploadInfo.messages = data.info;
                this.$emit('change', this.uploadInfo.messages);
            }
            if(data && data.warnings && data.warnings.length > 0) {
                that.uploadWarnings.messages = data.warnings;
                this.$emit('change', this.uploadWarnings.messages);
            }
            if(data && data.errors && data.errors.length > 0) {
                that.uploadErrors.messages = data.errors;
                this.$emit('change', this.uploadErrors.messages);
            }
        },
        getErrorMessages(resp) {
            return resp.response.data.errors ? resp.response.data.errors : [resp.message];
        },
        getWarningMessages(resp) {
            return resp.response.data.warnings ? resp.response.data.warnings : [];
        },

        clearAll() {
            this.clearInfo();
            this.clearWarnings();
            this.clearErrors();
        },
        clearInfo() {
            this.uploadInfo.messages = [];
            this.uploadInfo.headline = '';
        },
        clearWarnings() {
            this.uploadWarnings.messages = [];
            this.uploadWarnings.headline = '';
        },
        clearErrors() {
            this.uploadErrors.messages  = [];
            this.uploadErrors.headline = '';
        }
    }
};
</script>
